import React, { useContext, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import InputAdornment from '@mui/material/InputAdornment';
import { useNavigate } from 'react-router-dom';
import { Store } from '../App';
import { saveCandidateFeedback } from '../Service/AssesmentResultService';
import { loadSuccessPopup } from '../Utils/LoginUtils';
import { candidate_auth_signout, signout } from '../Service/LoginService';
const FeedbackForm = () => {
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState(0);
  const { data } = useContext(Store);
  const navigate = useNavigate();
  const assessmentId = data !== null ? data?.assessmentId : "";

  const handleSubmit = (e) => {
    e.preventDefault();
    const datarequest = {
      rating,
      comment: feedback,
      assessmentId,
    }
    saveCandidateFeedback(datarequest).then(response => {
      loadSuccessPopup("Fedback submitted successfully.")
       candidate_auth_signout().then(response => {
            signout();
            window.onbeforeunload = null;
            navigate("/");
            setTimeout(() => {
                window.location.reload();
              }, 5000);
        }).catch(err => {
            console.log('error catched while signoutFromServer', err);
        })
    }).catch(err => {
      console.log('error catched while signoutFromServer', err);
    });
    setFeedback('');
    setRating(0);
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Box alignItems="center" mb={2}>
        <div className='d-flex justify-content-center mb-2'>
          <h2>Please provide Feedback</h2>
        </div>
        <div className='d-flex justify-content-center mb-2'>
          <Rating
            name="rating"
            value={rating}
            onChange={(e, newValue) => setRating(newValue)}

          />
        </div>
        <div className='d-flex justify-content-center mb-2'>
          <TextField
            multiline
            rows={6}
            placeholder="Enter your feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value.slice(0, 250))}
            variant="outlined"
            fullWidth={false}
            inputProps={{ maxLength: 250 }}
            sx={{ ml: 2, width: '60%' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ marginTop: '120px' }}>
                  {feedback.length}/250
                </InputAdornment>
              ),
            }}
          />
        </div>
      </Box>
      <div className='d-flex justify-content-center'>
        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
      </div>
    </Box>
  );
};

export default FeedbackForm;